// extracted by mini-css-extract-plugin
export default {"kat-breadcrumb-item":"Breadcrumb-module__kat-breadcrumb-item__1ZKfK","katBreadcrumbItem":"Breadcrumb-module__kat-breadcrumb-item__1ZKfK"};